import { request } from '@pb/utils'

export const postAppleWalletPassRequest = async (): Promise<any> => {
  const res = await request.post('v1/appleWalletPass', {
    data: {},
    use: { apiVersion: false },
  })
  return res
}

export const postGoogleWalletPassRequest = async (): Promise<any> => {
  const res = await request.post('v1/googleWalletPass', {
    data: {},
    use: { apiVersion: false },
  })
  return res
}
